var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"fields":_vm.fields,"items":_vm.mentorshipRequests,"responsive":""},scopedSlots:_vm._u([{key:"head()",fn:function(ref){
var label = ref.label;
return [_vm._v(" "+_vm._s(_vm._f("upper")(label))+" ")]}},{key:"cell(created_at)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatGreekDate")(item.created_at))+" ")]}},{key:"cell(mentee)",fn:function(ref){
var item = ref.item;
return [_c('b-card-text',{staticClass:"text-primary cursor-pointer",on:{"click":function($event){return _vm.$emit('show-mentee-details', item)}}},[_vm._v(" "+_vm._s(item.mentee.user.name)+" "+_vm._s(item.mentee.user.surname)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }